<template>
  <div class="container-fluid bmo-form">
    <div class="card-header py-3">
      <h6 class="m-0 font-weight-bold text-primary">Update User</h6>
    </div>
    <div class="card-body text-align-left" v-if="userData !== null">
      <Form type="Update" :item="userData" @submit="handleFormSubmit" />
    </div>

    <!-- close card body -->
  </div>
  <!-- close container-fluid -->
</template>

<script>
import Form from '@/components/Forms/UserForm.vue';
import UserApiRequest from '@/components/ApiRequester/Users.js';
import router from '@/router';

const ApiRequester = new UserApiRequest();

export default {
  name: 'UpdateUser',
  components: {
    Form,
  },
  data: () => ({
    userData: null,
  }),
  created() {
    document.getElementById('loader').classList.add('active');
    ApiRequester.detail({ id: this.$route.params.id }).then((response) => {
      this.userData = response.data    
      document.getElementById('loader').classList.remove('active');
    }).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });
  },
  methods: {
    handleFormSubmit() {
      router.push('/users');
    }
  }
};
</script>
